import { Permissions } from "./types";

export const setPermissions = (userPermissions: Permissions): Permissions => {
  return { ...permissionDefaults, ...userPermissions };
};

export const permissionDefaults: Permissions = {
  canViewEhsConfig: false,
  canViewUsers: false,
  canEditUsers: false,
  canViewMyProfile: true,
  canViewCustomers: false,
  canEditCustomers: false,
  canAssignApplications: false,
  canChangeCustomers: false,
  canViewAppConfig: false,
  canEditAppConfig: false,
  canDeleteAppConfig: false,
  canEditSSO: false,
  canDeleteSSO: false,
  canViewSSO: false,
  canViewRole: false,
  canViewPolicy: false,
  canEditRole: false,
  canAssignRole: false,
  canManageLocations: false,
  canManageOrgHierarchies: false,
  canCreateActionItem: true,
  canViewLocationsMenu: false,
  canViewHierarchiesMenu: false,
  canViewUnpurchased: false,
  canManageUserPreferences: false,
  canViewPersons: false,
  canEditPersons: false,
  canViewSensitiveData: false,
  canEditSensitiveData: false,
  canExploreReportingData: false,
};
